import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";

export function ScrollToTop({ label = "Вернуться к началу истории" }: { label?: string }) {
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => setVisible(window.scrollY > Math.max(420, window.innerHeight * .65));
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return <AnimatePresence>{visible && <motion.button
    type="button"
    className="reader-scroll-top"
    aria-label={label}
    title="Наверх"
    initial={reduceMotion ? false : { opacity: 0, y: 20, scale: .88 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 14, scale: .9 }}
    transition={{ type: "spring", stiffness: 360, damping: 25 }}
    onClick={() => window.scrollTo({ top: 0, behavior: reduceMotion ? "instant" : "smooth" })}
  ><ArrowUp /><span>Наверх</span><i aria-hidden="true" /></motion.button>}</AnimatePresence>;
}
